<div class="default-desktop-item">
  <ng-content></ng-content>
</div>
